import axios from 'axios'
import moment from 'moment'

import config from '@/config'
import store from '@/store'
import urls from '@/router/urls'

const parseErrorResponse = async (error, path, apiParams) => {
  if (!error.response) {
    return 'Not connected'
  }

  if (store.getters.authToken && error.response.status === 401) {
    store.dispatch('clearAuthToken')
    return 'Authentication required'
  }

  if (!error.response.data || !error.response.data.message) {
    return 'Unknown backend error'
  }

  if (error.response.data.code >= 100 && error.response.data.code <= 104) {
    return error.response.data
  }

  const errorCode = error.response.data.code
    ? `ERROR ${ error.response.data.code }:`
    : 'ERROR:'

  const errMessage = `${ errorCode } ${ error.response.data.message }`

  let paramsStr = `url: ${ path }`
  if (apiParams) {
    paramsStr = `${ paramsStr }, params: ${ JSON.stringify(apiParams) }`
  }

  // send error info to the back-end
  const params = {
    secret_key: 'lfdksjfdsopi93kfdnsdk§gfrsd',
    client_timestamp: moment().format(),
    message: errMessage,
    type: 'API Error',
    component: 'axios',
    line_nr: '0',
    params: paramsStr,
    browser: navigator.userAgent
  }
  // console.log(params)

  await axios.post(`${ config.API_BASE }${ urls.SaveError }`, params)

  return errMessage
}

export default {
  get (path = '', params = null) {
    let headers = {}

    if (store.getters.authToken) {
      headers.Authorization = `Bearer ${ store.getters.authToken }`
    }

    return axios
      .get(`${ config.API_BASE }${ path }`, { params, headers })
      .catch(err => {
        throw new Error(parseErrorResponse(err, path, params))
      })
  },

  post (path = '', params = null, isFormData = false) {
    let headers = {}
    let responseType = {}

    if (store.getters.authToken) {
      headers.Authorization = `Bearer ${ store.getters.authToken }`
    }

    if (isFormData) {
      headers['Content-Type'] = 'multipart/form-data'
      responseType['responseType'] = 'blob'
    }

    return axios
      .post(`${ config.API_BASE }${ path }`, params, { headers, ...responseType })
      .catch(err => {
        const err_ = parseErrorResponse(err, path, params)
        if (typeof err_ === 'string') {
          throw new Error(err_)
        } else {
          throw err_
        }
      })
  },

  put (path = '', params = null, isFormData = false) {
    let headers = {}

    if (store.getters.authToken) {
      headers.Authorization = `Bearer ${ store.getters.authToken }`
    }

    if (isFormData) {
      headers['Content-Type'] = 'multipart/form-data'
    }

    return axios
      .put(`${ config.API_BASE }${ path }`, params, { headers })
      .catch(err => {
        throw new Error(parseErrorResponse(err, path, params))
      })
  },

  delete (path = '', data = null) {
    let headers = {}

    if (store.getters.authToken) {
      headers.Authorization = `Bearer ${ store.getters.authToken }`
    }

    return axios
      .delete(`${ config.API_BASE }${ path }`, { data, headers })
      .catch(err => {
        throw new Error(parseErrorResponse(err, path, data))
      })
  },
}
